import { CellRenderer, MainColumns } from '../../../../../components/TableGrid';

export const getQueriesPanelTableColumns = () => {
  return [
    {
      headerName: '',
      field: 'name',
      cellClass: 'companyTitle',
      cellRenderer: CellRenderer.Link,
      flex: 1,
    },
  ] as MainColumns[];
};
